import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import Navigation from 'components/site/Navigation';
import Logo from 'components/site/Logo';
import s from './Header.css';

// import { defineMessages, FormattedMessage } from 'react-intl';
// import LanguageSwitcher from 'components/site/LanguageSwitcher';
// import logoUrl from './logo-small.png';
// import logoUrl2x from './logo-small@2x.png';

class Header extends React.Component {
  render() {
    return (
      <div className={s.root}>
        <div className={s.container}>
          <Navigation />
          <Logo className={s.logo} />
          {/*
          <LanguageSwitcher />
          <div className={s.banner}>
            <h1 className={s.bannerTitle}>
              <FormattedMessage {...messages.bannerTitle} />
            </h1>
            <FormattedMessage tagName="p" {...messages.bannerDesc} />
          </div>
          */}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Header);
